export const Constant = {
  apiTimeout: 90 * 1000, // 90 seconds,
  Million: 1000000,
  API: {
    GET_INDUSTRIES: "industry",
    CALCULATE_UNSIGNED_REVENUE: "org/savings",
    GET_AI_VALYE: "ai-value",
    GET_AI_MATURITY_EVALUATION: "ai-maturity-evaluation",
    GET_AI_STRATEGIC_IMPACT: "ai-strategic-impact",
    GET_AI_EXECUTION_COST: "ai-execution-cost",
    GET_AI_GAP_ANALYSIS: "ai-gap-analysis",
    GET_FAQS: "faqs",
    TESTIMONIALS: 'testimonials',
    AI_USERCASE_DOCUMENT: '/generate-company-pdf'
  },
  STORAGE_KEYS: {
    USER_INFO: "userInfo",
    TARGET_RANGE: 'target_range',
    REVENUE_REPORT: 'revenue_report',
  },
  REVENUE_RAGE: {
    MIN: 1,
    MAX: 500,
    STEP: 1,
  },
  EMPLOYEE_RAGE: {
    MIN: 50,
    MAX: 10000,
  },
  INVENTORY_RAGE: {
    MIN: 0,
    MAX: 200,
    STEP: 1,
  },
  AI_STRATEGY: ['Define the AI Vision',
    'Measure AI Maturity',
    'Analyze External Trends',
    'Initiate the AI Strategy',
    'Communicate the AI Strategy',
    'Set Adoption Goals for AI Roadmap',
    'Identify Priorities for AI Portfolio',
    'Measure AI Strategy Success',
    'Establish Process to Refine AI Strategy'
  ],
  AI_VALUE: ['Prioritize initial AI use cases',
    'Define value for initial AI use cases',
    'Run initial AI pilots',
    'Track value of initial use cases',
    'Establish process to prioritize AI portfolio',
    'Introduce product management practices',
    'Launch an initial AI product',
    'Implement AI FinOps practices',
    'Set up AI value monitoring system',
    'Establish an AI product portfolio'
  ],
  AI_ORGANISATION: ['Create an AI resourcing plan',
    'Set up an AI community of practice',
    'Appoint an AI leader',
    'Set up an initial AI team/center of excellence',
    'Establish AI target operating model',
    'Form initial external AI partnerships',
    'Set up process to manage AI partnerships'
  ],
  AI_PEOPLE_AND_CULTURE: ['Create an initial AI workforce plan',
    'Set up process for review of roles and job redesign',
    'Create an AI change management plan',
    'Create initial AI awareness campaigns',
    'Set up process to evaluate AI workforce impact',
    'Launch an AI literacy program',
    'Define business champions to drive AI literacy',
    'Set up monitoring of employee readiness for AI'
  ],
  AI_GOVERNANCE: ['Identify key AI risks and mitigation',
    'Define initial AI policies',
    'Establish ethical principles',
    'Secure leadership buy-in',
    'Set up enforcement mechanisms',
    'Define decision rights',
    'Set up governance board',
    'Define governance operating model',
    'Leverage AI literacy programs',
    'Pilot governance tooling'
  ],
  AI_ENGINEERING: ['Establish build vs. buy framework',
    'Select vendors for initial AI usecases',
    'Set up a sandbox environment',
    'Define library of design patterns',
    'Define Ai reference architecture',
    'Create ab AI vendor and application strategy',
    'Establish MLOps/ ModelOps practice',
    'Set up AI observability system',
    'Design and embed AI UI/UX best practices',
    'Stand up AIplatform engineering'
  ],
  AI_DATA: ['Assess data readiness for initial AI use cases',
    'Implement data readiness plan',
    'Build data analytics for AI',
    'Gain buy-in to evolve data capabilities for AI',
    'Extend data governance to support AI',
    'Evolve data capabilities for AI',
    'Establish an AI data quality framework',
    'Adapt metadata Practices for AI',
    'Implement data observability for AI'
  ]
};

export const formatNumberInMillions = (value) => {
  const formater = Intl.NumberFormat("en", {
    notation: "standard",
    maximumFractionDigits: 0,
  });
  return formater.format(value);
};

export const SECTION_NAMES = {
  COMAPANY_INFO: 'Company Info',
  AI_MATURITY_EVALUATION: 'AI Maturity Evaluation',
  GAP_ANALYSIS: 'Gap Analysis',
  AI_VALUE: 'AI Value',
  STRATEGIC_IMPLICATIONS: 'Strategic Implications',
  AI_ROADMAP: 'AI Roadmap',
  AI_USE_CASE_BOOKLET: 'AI Use Case Booklet',
  TIMELINE_AND_COST: 'Implication Timeline and Cost',
  UNIQUIE_DIFFERENTIATORS: 'Unique Differentiators',
  TRACK_RECORD: 'Track Record',
  FAQS: 'FAQs',
  CLIENT_ASSISTANCE_CHANNEL: 'Client Assistance Channels',
};

export const EVALAUTION_STAGES = {
  AI_STRATEGY: 'ai_strategy',
  AI_VALUE: 'ai_value',
  AI_ORGANISATION: 'ai_organisation',
  AI_PEOPLE_AND_CULTURE: 'ai_people_and_culture',
  AI_GOVERNANCE: 'ai_governance',
  AI_ENGINEERING: 'ai_engineering',
  AI_DATA: 'ai_data',
};